import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { forIn } from 'lodash'
import AutosizeInput from 'react-input-autosize'
import Icon from 'components/icon/icon'

import { getUserRoles } from 'state/selectors'

import ProfilePicture from 'components/profile/profile-picture'
import MessageList from 'components/message-list/message-list'
import DropZoneIndicator from 'components/drop-zone-indicator/drop-zone-indicator'

import ChatTitle from 'components/chat/title'

import DockChatSearch from './dock-chat-search'

import {
	isMobile,
	scaleFactor,
	doClickEventListeners,
	parseFileArray,
	eventContainsFiles,
	getMobileOperatingSystem
} from 'utils'

import MobileSubMenu from 'components/mobile/mobile-sub-menu'
import ToggleButtons from 'components/toggle-buttons/toggle-buttons'

import {
	toggleChat,
	closeChat,
	sendMessage,
	addUserToChat,
	fetchMoreMessages,
	handleSeen,
	setTyping,
	saveChatTitle,
	changeTitle,
	openModal,
	openHeaderTab,
	createOrReturnChat,
	getMissingEntities,
	clearExtraMessages,
	setOnboardingStep
} from 'state/actions'

import { getLastUnreadItem } from 'state/selectors'

import isEqual from 'react-fast-compare'

import DockChatInput from './dock-chat-input'

class DockChat extends Component {
	state = {
		chats: [],
		userNameInputValue: '',
		userSuggestions: [],
		hoveredSuggestionIndex: 0,
		recipientSelectorOpen: false,
		recipientSelectorVisible: false,
		searchOpen: false,
		isOpen: false,
		isMounted: true,
		isNameBeingEdited: false,
		pendingMessages: [],
		openCallout: '',
		isFetchingNewMessages: false,
		hasFetchedAll: false,
		hasMounted: false,
		keyboardHeight: 0,
		inputsHeight: 128,
		tempChatTitle: '',
		isDraggingFileOver: false,
		activeSearchResult: null,
		repliedMessage: null
	}

	titleFlashInterval = null

	filteredSuggestions = []
	inputContainer = null
	chatRef = null
	chatUserIds = []
	requestedMissingUserIds = []

	shouldComponentUpdate = (nextProps, nextState) => {
		const oldPropsToCompare = {
			activeChat: this.props.activeChat,
			chatFocusData: this.props.chatFocusData,
			chatId: this.props.chatId,
			onlineUsers: this.props.onlineUsers,
			userData: this.props.userData,
			chatObject: this.props.chatObject,
			typingUserData: this.props.typingUserData,
			isFocused: this.props.isFocused
		}

		const newPropsToCompare = {
			activeChat: nextProps.activeChat,
			chatFocusData: nextProps.chatFocusData,
			chatId: nextProps.chatId,
			onlineUsers: nextProps.onlineUsers,
			userData: nextProps.userData,
			chatObject: nextProps.chatObject,
			typingUserData: nextProps.typingUserData,
			isFocused: nextProps.isFocused
		}

		const arePropsEqual = isEqual(oldPropsToCompare, newPropsToCompare)
		const isStateEqual = isEqual(this.state, nextState)

		if (arePropsEqual && isStateEqual) {
			return false
		}

		return true
	}

	componentDidMount = _ => {
		const {
			optimistic,
			activeChat,
			chatObject
		} = this.props

		this.isOpen = true

		let tempState = {
			...this.state,
			isOpen: optimistic ? true : activeChat.isOpen
		}

		if (!optimistic) {
			if (this.chatUserIds.length <= 1 && tempState.isOpen && !chatObject.team_id) {
				tempState.recipientSelectorOpen = true

				setTimeout(_ => {
					this.focusNameInput()
				}, 2);
			} else {
				setTimeout(_ => {
					this.focusChatInput()
				}, 100)
			}
		}

		setTimeout(_ => {
			this.setState(tempState, _ => {
				this.handleSeen()

				// why the fuck does this sometimes not work??
				if (this.state.isOpen) {
					this.setFocus(true)
				}
			})
		}, 1)

		// it loads a bit slow mounting both at the same time
		setTimeout(_ => {
			this.setState({
				hasMounted: true
			})
		}, 300)
	}

	componentWillMount() {
		this.getUserIds()

		doClickEventListeners(this.handleClick)

		if (isMobile()) {
			window.addEventListener('resize', this.recalcLayout)

			window.addEventListener('keyboardWillShow', this.keyboardHeightChanged)
			window.addEventListener('keyboardWillHide', this.keyboardHeightChanged)
			window.addEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
		} else {
			window.addEventListener('blur', this.handleBlur)
		}
	}

	componentWillUnmount() {
		doClickEventListeners(this.handleClick, true)

		if (isMobile()) {
			window.removeEventListener('resize', this.recalcLayout)
			window.removeEventListener('keyboardWillShow', this.keyboardHeightChanged)
			window.removeEventListener('keyboardWillHide', this.keyboardHeightChanged)
			window.removeEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
		} else {
			window.removeEventListener('blur', this.handleBlur)
		}

		this.clearExtraMessages() // stops chats getting too long

		this.doFlashTitle(false)
	}

	getUserIds = (props = this.props) => {
		if (props.chatObject && props.chatObject.userIds) {
			this.chatUserIds = props.chatObject.userIds
		}

	}

	recalcLayout = _ => {
		this.forceUpdate()
	}

	handleBlur = _ => {
		const {
			isFocused,
			setFocus
		} = this.props

		if (isFocused) {
			setFocus(null)
		}
	}

	keyboardHeightChanged = e => {
		const os = getMobileOperatingSystem()

		if (os == 'iOS') {
			this.setState({
				keyboardHeight: e.keyboardHeight ? (e.keyboardHeight * scaleFactor()) : 0
			})
		}
	}

	getLastUnreadItem = _ => {
		const {
			optimistic,
			userData,
			chatObject,
			entities
		} = this.props

		if (optimistic) {
			return null
		}

		return getLastUnreadItem(chatObject, userData, entities)
	}

	getRef = key => {
		return (this.dockChatInputRef && this.dockChatInputRef[key]) ? this.dockChatInputRef[key] : null
	}

	handleClick = e => {
		const {
			openCallout,
			recipientSelectorOpen
		} = this.state

		if (this.getRef('emojiRef') && this.getRef('buttonContainerRef') && openCallout === 'emojis') {
			if (!this.getRef('emojiRef').contains(e.target) && !this.getRef('buttonContainerRef').contains(e.target)) {
				this.setState({
					openCallout: 'emojis',
				})
			}
		}

		if (isMobile() && this.recipientSelectorRef && recipientSelectorOpen) {
			if (!this.recipientSelectorRef.contains(e.target)) {
				this.setState({
					recipientSelectorOpen: false
				})
			}
		}

		if (!this.chatRef.contains(e.target)) {
			this.handleFocusChange(false)
		}
	}

	componentWillUpdate = (nextProps, nextState) => {
		this.getUserIds(nextProps)

		if (this.props.optimistic) {
			return
		}

		let shouldUpdateState = false;
		let stateData = {
			...this.state
		}

		if (nextProps.activeChat.isOpen != this.props.activeChat.isOpen) {
			stateData.isOpen = nextProps.activeChat.isOpen

			if (nextProps.activeChat.isFocused) {
				this.setFocus()
			}

			shouldUpdateState = true
		}

		let nextChatItemsLength = []
		let currentChatItemsLength = []

		if (nextProps.chatObject.chat_items) {
			nextChatItemsLength = nextProps.chatObject.chat_items
		}

		if (this.props.chatObject.chat_items) {
			currentChatItemsLength = this.props.chatObject.chat_items
		}

		if (nextChatItemsLength.length != currentChatItemsLength.length) {
			shouldUpdateState = true
		}

		if (shouldUpdateState) {
			this.setState({
				...stateData,
				pendingMessages: []
			})
		}

		setTimeout(_ => {
			if (this.getLastUnreadItem()) {
				this.handleSeen()
			} else {
				this.doFlashTitle(false)
			}
		}, 2)
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (!prevState.recipientSelectorOpen && this.state.recipientSelectorOpen) {
			this.setState({
				recipientSelectorVisible: true
			})
		} else if (prevState.recipientSelectorOpen && !this.state.recipientSelectorOpen && this.props.chatObject) {
			this.setState({
				recipientSelectorVisible: false
			})
		}

		if (this.props.chatObject && prevProps.chatObject) {
			if (this.props.chatObject.chat_items.length > prevProps.chatObject.chat_items.length) {
				this.handleSeen()
			}
		}
	}

	handleSeen = _ => {
		// This always runs on update, if there's anything unread.

		const {
			isFocused,
			userData,
			handleSeen
		} = this.props

		const lastUnreadItem = this.getLastUnreadItem()

		if (lastUnreadItem) {
			if (isFocused && this.state.isOpen) {
				handleSeen(lastUnreadItem, userData)

				this.doFlashTitle(false)
			} else {
				//this.flashTitle(false, false, 'seen')
				this.doFlashTitle(true, lastUnreadItem)
			}
		}
	}

	toggleChat = _ => {
		if (isMobile()) {
			return
		}

		const {
			isNameBeingEdited,
			isOpen
		} = this.state

		const {
			toggleChat,
			index,
			isFocused,
			chatObject
		} = this.props

		if (!isNameBeingEdited) {
			if (isOpen && isFocused) {
				this.setFocus()
			} else {
				this.setFocus(true)
				this.focusChatInput()
			}

			toggleChat(index, chatObject ? chatObject.id : null)
		}
	}

	toggleRecipientSelector = _ => {
		let isOpening = this.state.recipientSelectorOpen

		setTimeout(_ => {
			this.setState({
				recipientSelectorOpen: !this.state.recipientSelectorOpen
			})

			if (!isOpening) {
				this.refs.nameInput.focus()
			}
		}, 5)
	}

	toggleNameEditor = _ => {
		setTimeout(_ => {
			this.setState({
				isNameBeingEdited: !this.state.isNameBeingEdited
			})
		}, 5)
	}

	toggleSearch = _ => {
		setTimeout(_ => {
			this.setState({
				searchOpen: !this.state.searchOpen
			})
		}, 5)
	}

	focusChatInput = _ => {
		if (!isMobile()) {
			setTimeout(_ => {
				if (this.getRef('messageInput') && this.state.isOpen) {
					this.getRef('messageInput').focus()
				}
			}, 1)
		}
	}

	closeChat = _ => {
		this.isOpen = false

		this.props.closeChat(this.props.initialChat, this.props.index)
		this.setTyping(false)
	}

	sendMessage = _ => {
		const {
			chatObject,
			onlineUsers,
			activeChat,
			sendMessage,
			index,
			initialChat,
			closeChat,
			createOrReturnChat,
			setOnboardingStep,
			userData,
			setCurrentBigChat
		} = this.props

		const {
			repliedMessage
		} = this.state

		if (this.chatUserIds.length < 2 && !chatObject.team_id) {
			return
		}

		let messageString = this.getRef('messageInput').value

		// add <br> tags from newlines
		messageString = messageString.replace(/(?:\r\n|\r|\n)/g, '<br />')

		if (!messageString) {
			return
		}

		const stateData = {
			...this.state
		}

		sendMessage(chatObject, messageString, onlineUsers, repliedMessage ? repliedMessage.id : null)

		setOnboardingStep('SEND_CHAT_MESSAGE', userData)

		stateData.recipientSelectorOpen = false

		if (activeChat.tempId && activeChat.tempId !== activeChat.id) {
			closeChat(initialChat, index, true)
			createOrReturnChat({
				id: activeChat.tempId
			}, null, null, false, index)

			if (setCurrentBigChat) {
				setCurrentBigChat(activeChat.tempId)
			}

			return
		}

		setTimeout(_ => {
			this.setTyping(false)
		})

		const pendingMessages = [...this.state.pendingMessages]
		pendingMessages.push(messageString)

		this.setState({
			...stateData,
			pendingMessages,
			repliedMessage: null
		})
	}

	focusNameInput = _ => {
		this.refs.nameInput.focus()
	}

	setFocus = isFocused => {
		const {
			optimistic,
			setFocus
		} = this.props

		if (optimistic) {
			return
		}

		window.requestAnimationFrame(_ => {
			if (this.state.isOpen) {
				setFocus(isFocused ? this.props.chatObject.id : null)
			}
		})
	}

	changeNameInput = (event) => {
		this.generateSuggestions(event.target.value, false)

		this.setState({
			userNameInputValue: event.target.value,
		})
	}

	generateSuggestions = (query, debounce) => {
		const {
			accountData,
			userRoles,
			allUsers,
			userData,
		} = this.props

		let delay = 0

		if (debounce) {
			delay = 10
		}

		setTimeout(_ => {
			let tempSuggestions = []
			let searchQuery = this.state.userNameInputValue

			if (query) {
				searchQuery = query.toLowerCase()
			}

			if (searchQuery) {
				accountData.users.forEach(userId => {
					// Guests can't invite other guests to chats, but everyone else can.
					if (accountData.guestIds.indexOf(userId) === -1 || !userRoles.guest) {
						const user = allUsers[userId]
						const searchString = (user.first_name + ' ' + user.last_name).toLowerCase()

						if (!searchString.includes(searchQuery) || user.id == userData.id) {
							return
						}

						if (this.chatUserIds.find(chatUserId => {
							return chatUserId === user.id
						})) {
							return
						}

						tempSuggestions.push(user)
					}
				})
			}
			this.setState({
				userSuggestions: tempSuggestions
			})
		}, delay)

	}

	handleKeyPress = key => {
		let newHoveredSuggestionIndex = null

		switch (key) {
			case 'ArrowDown':
				if (this.state.hoveredSuggestionIndex < (this.filteredSuggestions.length - 1)) {
					newHoveredSuggestionIndex = (this.state.hoveredSuggestionIndex + 1)
				}
				break
			case 'ArrowUp':
				if (this.state.hoveredSuggestionIndex > 0) {
					newHoveredSuggestionIndex = (this.state.hoveredSuggestionIndex - 1)
				}
				break
			case 'Enter':
				this.addOrRemoveUser()
				break
			case 'Backspace':
				const {
					chatObject,
					allUsers,
					userData
				} = this.props

				const {
					userNameInputValue
				} = this.state

				if (chatObject && this.chatUserIds.length > 1 && !userNameInputValue) {
					const chatUsersLength = this.chatUserIds.length

					let lastUserId = this.chatUserIds[(chatUsersLength - 1)]
					let lastUser = allUsers[lastUserId]

					if (lastUser.id == userData.id) {
						lastUserId = this.chatUserIds[(chatUsersLength - 2)]
						lastUser = allUsers[lastUserId]
					}

					if (lastUser) {
						this.addOrRemoveUser(lastUser)

						if (chatUsersLength > 1) {
							this.setState({
								recipientSelectorVisible: false
							})
						}
					}
				}
				break
		}

		if (newHoveredSuggestionIndex !== null) {
			this.setState({
				hoveredSuggestionIndex: newHoveredSuggestionIndex
			})
		}
	}

	setHoveredSuggestionIndex = hoveredSuggestionIndex => {
		this.setState({
			hoveredSuggestionIndex
		})
	}

	addOrRemoveUser = (user = null) => {
		const {
			initialChat,
			addUserToChat
		} = this.props

		if (!user) {
			user = this.filteredSuggestions[this.state.hoveredSuggestionIndex]
		}

		if (user && typeof user !== 'undefined') {
			addUserToChat(user, initialChat)

			setTimeout(_ => {
				this.setState({
					userNameInputValue: '',
					hoveredSuggestionIndex: 0
				})
			}, 10)

			this.generateSuggestions(null, true)
		}
	}

	setTyping = isTyping => {
		const {
			setTyping,
			chatObject,
			accountData,
			userData
		} = this.props

		setTyping(isTyping, chatObject.id, accountData.id, userData.id)
	}

	doFlashTitle = (isStart, unreadMessage) => {
		const {
			allUsers,
			pageTitle,
			changeTitle,
			currentlyFlashingChat,
			setCurrentlyFlashingChat,
			chatObject
		} = this.props

		if (isStart) {
			if (!currentlyFlashingChat) {
				setCurrentlyFlashingChat(chatObject.id)

				if (!this.titleFlashInterval) {
					this.isFlashed = false

					this.titleFlashInterval = setInterval(_ => {
						let sender = null

						let title = pageTitle

						if (!this.isFlashed) {
							if (unreadMessage.type == 'message') {
								sender = allUsers[unreadMessage.item.sender_id]

								if (sender) {
									title = `${sender.first_name} ${sender.last_name} has sent you a message`
								}
							} else {
								sender = allUsers[unreadMessage.item.user_id]

								if (sender) {
									title = `${sender.first_name} ${sender.last_name} has sent you a file`
								}
							}
						}

						changeTitle(title, true)

						this.isFlashed = !this.isFlashed
					}, 1500)
				}
			}
		} else if (this.titleFlashInterval) {
			clearInterval(this.titleFlashInterval)
			setCurrentlyFlashingChat(null)

			changeTitle(pageTitle)

			this.titleFlashInterval = null
			this.isFlashed = false
		}
	}

	clearExtraMessages = _ => {
		const {
			chatObject,
			clearExtraMessages
		} = this.props

		clearExtraMessages(chatObject)
	}

	toggleEmojis = _ => {
		setTimeout(_ => {
			this.setState({
				openCallout: (this.state.openCallout === '' || this.state.openCallout === 'giphy') ? 'emoji' : ''
			})
		}, 1)
	}

	toggleGiphy = _ => {
		setTimeout(_ => {
			this.setState({
				openCallout: (this.state.openCallout === '' || this.state.openCallout === 'emoji') ? 'giphy' : ''
			})
		}, 1)
	}

	uploadFile = versions => {
		this.props.openModal('upload', 'task_file', {
			task: null,
			file: null,
			chat: this.props.chatObject,
			versions,
			project_id: null,
			uploaded_to_task: false
		})
	}

	fetchMore = (offset, callback) => {
		this.setState({
			isFetchingNewMessages: true
		})

		this.props.fetchMoreMessages(this.props.chatObject.id, offset, fetchedAll => {
			callback()

			this.setState({
				isFetchingNewMessages: false,
				hasFetchedAll: fetchedAll
			})
		})
	}

	handleFocusChange = isNowFocused => {
		if (isMobile()) {
			return
		}

		const {
			isFocused
		} = this.props

		if (isFocused == isNowFocused) {
			return
		}

		this.setFocus(isNowFocused)

		setTimeout(_ => {
			this.recalcLayout()
		}, 1)
	}

	handleChatNameChange = value => {
		this.setState({
			tempChatTitle: value
		})
	}

	handleDrop = e => {
		e.preventDefault()
		e.stopPropagation()

		const dt = e.dataTransfer
		const files = dt.files

		const fileArray = []

		if (files) {
			forIn(files, file => {
				if (typeof file == 'object') {
					fileArray.push(file)
				}
			})
		}

		if (fileArray) {
			parseFileArray(fileArray, this.uploadFile)
		}

		this.setState({
			isDraggingFileOver: false
		})
	}

	handleDragOver = (e, isLeave = false) => {
		e.preventDefault()
		e.stopPropagation()

		if (!isLeave) {
			if (eventContainsFiles(e) && !this.state.isDraggingFileOver) {
				this.setState({
					isDraggingFileOver: true
				})
			}
		} else {
			this.setState({
				isDraggingFileOver: false
			})
		}
	}

	clickChatBox = _ => {
		this.setFocus(true)

		if (this.chatUserIds.length > 1 && this.state.recipientSelectorOpen) {
			this.setState({
				recipientSelectorOpen: false
			})
		}
	}

	updateInputsHeight = newHeight => {
		this.setState({
			inputsHeight: newHeight
		})
	}

	getMissingUser = userId => {
		// if they're not from our account(s), we'll need to fetch 'em

		if (this.requestedMissingUserIds.indexOf(userId) == -1) {
			this.requestedMissingUserIds.push(userId)

			const {
				getMissingEntities
			} = this.props

			getMissingEntities({
				users: [userId]
			})
		}
	}

	setSearchResult = index => {
		this.setState({
			activeSearchResult: index
		})
	}

	maximiseChat = () => {
		const { chatObject, accountData } = this.props

		window.open(`/${accountData.slug}/chat?id=${chatObject.id}`, 'hasslChat')
	}

	replyMessage = message => {
		this.setState({
			repliedMessage: message
		})
	}

	cancelReplyEntity = () => {
		this.setState({
			repliedMessage: null
		})
	}

	render() {
		const {
			typingUserData,
			chatObject,
			saveChatTitle,
			userData,
			allUsers,
			isFocused,
			optimistic,
			chatId,
			isBigChat,
			onlineUsers,
			cancelNewChat,
			setIsAsideVisibleOnSmallScreens
		} = this.props

		const {
			isOpen,
			userSuggestions,
			recipientSelectorVisible,
			recipientSelectorOpen,
			searchOpen,
			isNameBeingEdited,
			userNameInputValue,
			tempChatTitle,
			hasMounted,
			inputsHeight,
			isDraggingFileOver,
			openCallout,
			activeSearchResult,
			repliedMessage
		} = this.state

		const isTeamChat = chatObject && chatObject.team_id

		let className = ''
		let showDot = false

		const unreadMessages = this.getLastUnreadItem()

		this.filteredSuggestions = isTeamChat ? [] : userSuggestions.filter(user => {
			return this.chatUserIds.indexOf(user.id) === -1
		})

		if (isOpen) {
			className += ' open'
		}

		if (isFocused && isOpen) {
			className += ' focused'
		}

		if (unreadMessages) {
			if (!isFocused) {
				className += ' flashing'
			}

			if (!isOpen) {
				showDot = true
			}
		}

		let containerClassName = 'single-chat-container'

		if ((optimistic || this.chatUserIds.length < 2) && !isTeamChat) {
			containerClassName += ' disabled'
		}

		const mobilesubMenuOptions = [
			{
				icon: 'copy',
				label: 'Edit users',
				callback: this.toggleRecipientSelector
			},
			{
				icon: 'fe-edit-2',
				label: 'Edit chat name',
				callback: this.toggleNameEditor
			}
		]

		let chatContentHeight = 'calc(100vh - ' + this.state.keyboardHeight + 'px)'

		let chatTopClassName = 'chat-top'

		if (isNameBeingEdited && isMobile()) {
			chatTopClassName += ' editing-chat-name'
		}

		let chatContentClassName = 'chat-content'

		if (this.props.shouldBlockTransition && !hasMounted) {
			chatContentClassName += ' no-transition'
		}

		if (isDraggingFileOver) {
			chatContentClassName += ' dragging-file'
		}

		const chatUsers = this.chatUserIds.map(userId => {
			return allUsers[userId]
		}).filter(Boolean)

		const controls = (() => {
			if (isBigChat) {
				const buttons = (() => {
					let response = []

					if (!chatObject || chatObject.userIds.length === 1 && !chatObject.chat_items.length) {
						response = [
							{
								label: 'Cancel',
								icon: 'fe-x',
								callback: cancelNewChat
							}
						]
					} else if (!recipientSelectorOpen && !isNameBeingEdited) {
						response = [
							{
								isChecked: searchOpen,
								label: 'Search in chat',
								icon: `fe-search`,
								callback: this.toggleSearch
							},
							{
								isChecked: isNameBeingEdited,
								label: 'Edit chat name',
								icon: 'fe-edit-2',
								callback: this.toggleNameEditor
							}, {
								isChecked: recipientSelectorOpen,
								label: 'Edit users',
								icon: 'fe-user-plus',
								callback: this.toggleRecipientSelector
							}
						]
					} else if (recipientSelectorOpen) {
						response = [
							{
								isChecked: false,
								label: 'Done',
								icon: `fe-check`,
								callback: this.toggleRecipientSelector
							}
						]
					} else if (isNameBeingEdited) {
						response = [
							{
								isChecked: false,
								label: 'Done',
								icon: `fe-check`,
								callback: () => {
									saveChatTitle(tempChatTitle, chatObject)
									this.toggleNameEditor()
								}
							}, {
								isChecked: false,
								label: 'Cancel',
								icon: `fe-x`,
								callback: this.toggleNameEditor
							}
						]
					}

					if (setIsAsideVisibleOnSmallScreens) {
						response.push({
							label: 'Details',
							icon: 'fe-menu',
							callback: () => {
								setIsAsideVisibleOnSmallScreens(true)
							}
						})
					}

					return response
				})()

				return (
					<React.Fragment>
						<ToggleButtons
							buttons={buttons}
						/>
					</React.Fragment>
				)
			}

			return (
				<React.Fragment>
					<MobileSubMenu options={mobilesubMenuOptions} />
					{
						(isMobile() && !isTeamChat) &&
						<div className="mobile-chat-name-controls">
							<button onClick={_ => {
								saveChatTitle(tempChatTitle, chatObject)
								this.toggleNameEditor()
							}}>
								<Icon name="check" />
							</button>
							<button onClick={this.toggleNameEditor}>
								<Icon name="ban" />
							</button>
						</div>
					}
					<div
						className="chat-controls"
						onClick={e => { e.stopPropagation() }}
					>
						{
							<button onClick={this.maximiseChat}>
								<Icon name="fe-maximize-2" />
							</button>
						}
						{
							(isOpen && !isTeamChat) &&
							<button onClick={this.toggleRecipientSelector}>
								+
							</button>
						}
						{
							(isOpen && !isTeamChat) &&
							<button
								className={isNameBeingEdited ? 'alt' : null}
								onClick={this.toggleNameEditor}
							>
								<Icon name="fe-edit-2" />
								<Icon name="ban" />
							</button>
						}
						{
							!isMobile() &&
							<button
								onClick={_ => { this.closeChat(chatObject) }}
							>
								&times;
							</button>
						}
					</div>
				</React.Fragment>
			)
		})()

		const statusToDisplay = (() => {
			if (!isBigChat) {
				return null
			}

			const otherUserIfOne = chatUsers.length === 2 ? chatUsers.find(user => user.id !== userData.id) : null

			if (!otherUserIfOne) {
				return null
			}

			const otherUserOnline = onlineUsers.find(user => user.id === otherUserIfOne.id)

			if (!otherUserOnline || otherUserIfOne.status_if_online === 'OFFLINE') {
				return null
			}

			return {
				user: otherUserIfOne,
				status: otherUserIfOne.status_if_online
			}
		})()

		return (
			<li
				onClick={this.clickChatBox}
				className={className}
				ref={ref => this.chatRef = ref}
			>
				<i className={showDot ? "dot visible" : "dot"} />
				<div
					className={containerClassName}
					onDrop={this.handleDrop}
					onDragOver={this.handleDragOver}
					onDragLeave={e => this.handleDragOver(e, true)}
				>
					<div className={chatTopClassName}>
						<div className={'chat-top-strip'}>
							{
								isMobile() ?
									<div className="mobile-back-button mobile-only" onClick={_ => { this.closeChat(chatObject) }}>
										<Icon name="angle-left" />
									</div>
									: null
							}
							<div className="open-chat" onClick={this.toggleChat}>
								{isBigChat ?
									<ProfilePicture
										users={chatUsers}
										userData={userData}
									/>
									: null}
								<ChatTitle
									chat={chatObject}
									tempChatTitle={this.state.tempChatTitle}
									handleChatNameChange={this.handleChatNameChange}
									saveChatTitle={_ => { saveChatTitle(tempChatTitle, chatObject); this.toggleNameEditor() }}
									optimistic={optimistic}
									userId={userData.id}
									isNameBeingEdited={isNameBeingEdited}
								/>
							</div>
							{controls}
						</div>
						{(statusToDisplay && statusToDisplay.status) ?
							<span className={`status-display ${recipientSelectorVisible ? 'hidden' : ''}`}>
								{statusToDisplay.user.first_name} is currently {statusToDisplay.status.toLowerCase()}.
							</span>
							: null}
						{isBigChat &&
							<DockChatSearch
								setSearchResult={this.setSearchResult}
								activeSearchResult={activeSearchResult}
								chat={chatObject}
								visible={searchOpen}
								toggleSearch={this.toggleSearch}
							/>
						}
						<div
							ref={ref => { this.recipientSelectorRef = ref }}
							className={recipientSelectorVisible ? "chat-recipient-selector visible" : "chat-recipient-selector"}
							onClick={e => {
								this.focusNameInput()
								e.stopPropagation()
							}}
						>
							<div className={recipientSelectorVisible ? 'visible' : null}>
								<ul className="chat-recipient-list" onClick={this.focusNameInput}>
									{
										this.chatUserIds.map(userId => {
											const user = allUsers[userId]

											if (!user) {
												this.getMissingUser(userId)
												return null
											}

											if (user.id != userData.id) {
												return (
													<li key={user.id}>
														<span>
															{user.first_name + ' ' + user.last_name}
														</span>
														<button onClick={_ => { this.addOrRemoveUser(user) }}>
															&times;
														</button>
													</li>
												);
											}
										})
									}
									<AutosizeInput
										className="chat-recipient-input"
										placeholder={this.chatUserIds.length == 1 ? "Type in one or more user names" : null}
										value={userNameInputValue}
										onChange={this.changeNameInput}
										ref="nameInput"
										onKeyDown={e => { this.handleKeyPress(e.key) }}
									/>
								</ul>
							</div>
							{
								this.filteredSuggestions.length ?
									<ul className="chat-recipient-suggestion">
										{
											this.filteredSuggestions.map((user, index) => {
												if (this.chatUserIds.indexOf(user.id) === -1) {
													return (
														<li
															key={user.id}
															onMouseEnter={_ => { this.setHoveredSuggestionIndex(index) }}
															onMouseLeave={_ => { this.setHoveredSuggestionIndex(0) }}
															className={this.state.hoveredSuggestionIndex == index ? 'active' : null}
														>
															<button onClick={_ => { this.addOrRemoveUser(user) }}>
																<ProfilePicture user={user} isTiny={true} />
																<span>
																	{user.first_name + ' ' + user.last_name}
																</span>
															</button>
														</li>
													);
												}
											})
										}
									</ul>
									: null
							}
						</div>
					</div>
					<div
						className={chatContentClassName}
						style={isMobile() ? {
							height: chatContentHeight
						} : null}
					>
						<DropZoneIndicator />
						<MessageList
							typingUserData={typingUserData}
							hasFetchedAll={this.state.hasFetchedAll}
							fetchRequest={this.fetchMore}
							isFetching={this.state.isFetchingNewMessages}
							type="message"
							pendingMessages={this.state.pendingMessages}
							user={userData}
							messageObject={chatObject}
							replyEntity={this.replyMessage}
							repliedEntity={repliedMessage}
							cancelReplyEntity={this.cancelReplyEntity}
							typingUsers={optimistic ? [] : this.props.activeChat.typingUsers}
							setFocus={this.setFocus}
							optimistic={optimistic}
							keyboardHeight={this.state.keyboardHeight ? this.state.keyboardHeight : null}
							chatId={chatId}
							inputsHeight={inputsHeight}
							hasMounted={hasMounted}
							isOpen={isOpen}
							activeSearchResult={activeSearchResult}
						/>
						<DockChatInput
							handleFocusChange={this.handleFocusChange}
							setTyping={this.setTyping}
							chatObject={chatObject}
							uploadFile={this.uploadFile}
							openCallout={openCallout}
							sendMessage={this.sendMessage}
							optimistic={optimistic}
							isTeamChat={isTeamChat}
							recalcLayout={this.recalcLayout}
							toggleEmojis={this.toggleEmojis}
							toggleGiphy={this.toggleGiphy}
							ref={ref => this.dockChatInputRef = ref}
							userData={userData}
							hasMounted={hasMounted}
							inputsHeight={inputsHeight}
							updateInputsHeight={this.updateInputsHeight}
							isBigChat={isBigChat}
						/>
					</div>
				</div>
			</li>
		);
	}
}

const mapStateToProps = state => {
	return {
		pageTitle: state.auth.pageTitle,
		typingUserData: state.account.typingUserData,
		onlineUsers: state.account.onlineUsers,
		userRoles: getUserRoles(state),
		chatFocusData: state.auth.chatFocusData,
		allUsers: state.account.entities.users,
		allChatSearchResults: state.account.entities.chat_search_results
	}
}

export default withRouter(connect(mapStateToProps, {
	toggleChat,
	closeChat,
	addUserToChat,
	fetchMoreMessages,
	sendMessage,
	handleSeen,
	setTyping,
	saveChatTitle,
	changeTitle,
	openModal,
	openHeaderTab,
	createOrReturnChat,
	getMissingEntities,
	clearExtraMessages,
	setOnboardingStep
})(DockChat))



// WEBPACK FOOTER //
// ./src/layout/dock/dock-chat.jsx